var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebpageIcon = function SvgWebpageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    fillRule: "evenodd",
    d: "M11.502 4.846c-2.206 0-4.052.786-5.343 2.17-1.287 1.38-1.971 3.299-1.971 5.482v.991h26.306v-.991c0-2.182-.681-4.1-1.966-5.48-1.29-1.386-3.136-2.172-5.347-2.172zm-2.068 4.57a1.038 1.038 0 0 0 0 2.077h.077a1.038 1.038 0 1 0 0-2.077zm3.441 0a1.038 1.038 0 1 0 0 2.077h.077a1.038 1.038 0 1 0 0-2.077zm3.443 0a1.039 1.039 0 0 0 0 2.077h.077a1.038 1.038 0 1 0 0-2.077z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "m14.522 24.598 4.497-4.911a.38.38 0 0 1 .539-.02l.95.88a.38.38 0 0 1 .022.538l-.004.004-4.457 4.864-.01.01a1.44 1.44 0 0 1-.834.46l-1.034.174a.12.12 0 0 1-.14-.133l.115-1.065a1.44 1.44 0 0 1 .356-.801"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    fillRule: "evenodd",
    d: "M4.188 23.501v-7.935h26.306v7.935c0 2.182-.681 4.1-1.966 5.48-1.29 1.386-3.136 2.172-5.349 2.172H11.502c-2.212 0-4.058-.786-5.348-2.171-1.285-1.38-1.966-3.3-1.966-5.481m13.307-5.225a2.46 2.46 0 0 1 3.474-.133l.95.88a2.457 2.457 0 0 1 .136 3.471l-4.45 4.857a3.5 3.5 0 0 1-2.037 1.12l-1.034.174a2.197 2.197 0 0 1-2.548-2.403l.115-1.067a3.52 3.52 0 0 1 .876-1.966l.008-.009 4.506-4.92z",
    clipRule: "evenodd"
  })));
};
export default SvgWebpageIcon;